import { MobileBottomNav } from './MobileBottomNav';

export * from './MobileBottomNav';

export default MobileBottomNav;
